import { useState, useEffect } from 'react';
import { fetchTenantLogoDataUrl } from '../utils/pdfBranding';

// Fired (window-level) after an admin uploads or removes the tenant logo so
// any mounted header refreshes without a page reload.
export const TENANT_LOGO_UPDATED_EVENT = 'tenant-logo-updated';

/**
 * Returns the current tenant's logo as a data URL, or null when the tenant
 * has no logo (callers fall back to the platform logo / plain text).
 *
 * Reuses the same-origin logo-stream proxy + 15-minute module cache from
 * pdfBranding.js, so headers and PDF exports share one fetch. The backend
 * endpoint is tenant-scoped (SOC 2 CC6.1) — a user can only ever receive
 * their own tenant's logo.
 */
export function useTenantLogo() {
  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      fetchTenantLogoDataUrl().then((url) => {
        if (!cancelled) setLogoUrl(url);
      });
    };
    load();
    window.addEventListener(TENANT_LOGO_UPDATED_EVENT, load);
    return () => {
      cancelled = true;
      window.removeEventListener(TENANT_LOGO_UPDATED_EVENT, load);
    };
  }, []);

  return logoUrl;
}
